// extracted by mini-css-extract-plugin
export default {"addToCartControl":"AY-z","giftCard":"BY-z","btnContainer":"CY-z","cartButton":"DY-z","disabled":"EY-z"};